export enum GAEvent {
  COURSE_OPEN = 'course_open',
  COURSE_COMPLETED = 'course_completed',
  MEDITATION_COMPLETED = 'meditation_completed',
  WEEKLY_SURVEY_COMPLETED = 'weekly_survey_completed',
  EMOTION_LOGGED = 'emotion_logged',
  DAILY_INSIGHT_COMPLETED = 'daily_insight_completed',
  MINDFUL_MINUTE_COMPLETED = 'mindful_minute_completed',
  PODCAST_COMPLETED = 'podcast_played',
}
